import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useRbacSafeLandingPath } from 'src/hooks/useRbacSafeLandingPath';

/** Replaces a PermissionGate fallback / inline denial with a redirect to the RBAC safe landing. */
export const RbacDeniedRedirect: FC = () => {
  const to = useRbacSafeLandingPath();
  return <Navigate to={to} replace />;
};
